import {
    BANKNAMELISTPARTNER_SUCCESS,
    BANKNAMELISTPARTNER_FAILED,
    RESET_BANKNAMELISTPARTNER,
    LOADING_BANKNAMELISTPARTNER,
    NETWORK_ERROR_BANKNAMELISTPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKNAMELISTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKNAMELISTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKNAMELISTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_BANKNAMELISTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKNAMELISTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};